import { destructive, navigation } from '../../../../web/styles/colors';
import { CssSelectors, Layouts } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	bodyText: {
		color: '#061013',
		fontSize: 12,
	},
	container: {
		border: '1px solid #D3DBDE',
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		boxSizing: 'border-box',
		padding: '16px 30px',
		width: '100%',
	},
	containerMissingNoteWarning: {
		background: '#FFF2F4',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	headerButtons: {
		display: 'flex',
		justifyContent: 'space-between',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	noteActions: {
		...Layouts.horizontalStack(40),
	},
	noteActionsButton: {
		fontSize: 12,
	},
	noteActionsIcon: {
		height: 12,
		width: 'auto',
	},
	noteContent: {
		...CssSelectors.allDescendants(
			{
				fontSize: 12,
			},
			'.feed-card-note-content-more-toggle'
		),
	},
	noteInfo: {
		fontStyle: 'italic',
		padding: '5px 0',
		width: '100%',
	},
	showLessButton: {
		marginTop: 10,
	},
	showMoreLessButton: {
		fontSize: 12,
	},
	title: {
		color: navigation,
		fontSize: 12,
	},
	titleMissingNoteWarning: {
		color: destructive,
	},
});
